import {ClassComponent, Vnode} from 'mithril';
import app from 'flarum/forum/app';
import Button from 'flarum/common/components/Button';
import Tooltip from 'flarum/common/components/Tooltip';
import icon from 'flarum/common/helpers/icon';
import Picture from '../models/Picture';

interface ExifSummaryAttrs {
    picture: Picture
}

export default class ExifSummary implements ClassComponent<ExifSummaryAttrs> {
    showDetailed: boolean = false

    view(vnode: Vnode<ExifSummaryAttrs>) {
        const {picture} = vnode.attrs;

        const exif = picture.exif();

        if (!exif) {
            return null;
        }

        const make = ((exif.Make || '') + ' ' + (exif.Model || '')).trim();
        const exposureTimeParts = (exif.ExposureTime as string || '').split('/');
        const exposureDurationSeconds = exposureTimeParts.length === 2 ? parseInt(exposureTimeParts[0]) / parseInt(exposureTimeParts[1]) : 0;
        const exposureTime = exposureDurationSeconds > 0 ? (exposureDurationSeconds < 1 ? '1/' + Math.round(1 / exposureDurationSeconds) : (Math.round(exposureDurationSeconds * 10) / 10)) : exif.ExposureTime;
        const fNumberParts = (exif.FNumber as string || '').split('/');
        const fNumber = fNumberParts.length === 2 ? Math.round((parseInt(fNumberParts[0]) / parseInt(fNumberParts[1])) * 10) / 10 : exif.FNumber;

        // Other potentially interesting values
        // ApertureValue
        // FocalLength
        // ShutterSpeedValue

        return m('.CimaiseExifSection', [
            m('.CimaiseSectionTitle', m('h3', 'Camera')),
            m('.CimaiseExifSummary', [
                icon('fas fa-camera CimaiseExifSummaryIcon'),
                m('.CimaiseExifContent', [
                    m('.CimaiseExifSummaryMake', make || 'Camera model unknown'),
                    exposureTime ? m('.CimaiseExifSummaryInfo', [
                        exposureTime,
                        ' s',
                    ]) : null,
                    fNumber ? m('.CimaiseExifSummaryInfo', [
                        m('i', 'f'),
                        '/',
                        fNumber,
                    ]) : null,
                    exif.ISOSpeedRatings ? m('.CimaiseExifSummaryInfo', [
                        'ISO ',
                        exif.ISOSpeedRatings,
                    ]) : null,
                    Tooltip.component({
                        text: app.translator.trans('kilowhat-cimaise.forum.picture-show.show-exif'),
                    }, Button.component({
                        className: 'Button Button--icon',
                        icon: 'fas fa-ellipsis-h',
                        onclick: () => {
                            this.showDetailed = !this.showDetailed;
                        },
                    })),
                ]),
            ]),
            this.showDetailed ? m('.CimaiseExifAll', Object.keys(exif).map(key => m('dl', [
                m('dt', {
                    title: key,
                }, key),
                m('dd', (Array.isArray(exif[key]) ? exif[key] as string[] : [exif[key]]).map(value => m('span', (value === '' || value === null ? m('em', 'Empty') : (value + ''))))),
            ]))) : null,
        ]);
    }
}
